import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { alpha } from "@mui/material/styles";
import colors from "../../../theme/colors";

/**
 * CheckboxRow — the bordered, tint-on-check row used by every "check all that
 * apply" list. Presentational only: no react-final-form wiring.
 *
 * Shared by RffBooleanCheckbox (one boolean field per row) and
 * RffCheckboxArrayField (one array field, one row per option) so the two read
 * as the same control. They look identical because they ARE the same markup —
 * do not restyle one of them in isolation.
 */
const CheckboxRow = ({ checked, onChange, label, disabled, sx }) => (
  <FormControlLabel
    sx={(theme) => ({
      m: 0,
      alignItems: "flex-start",
      gap: 1.25,
      px: 2,
      py: 1.5,
      borderRadius: 2,
      border: "1px solid",
      borderColor: checked ? theme.palette.primary.main : colors.slate200,
      backgroundColor: checked
        ? alpha(theme.palette.primary.main, 0.06)
        : "#fff",
      transition: "border-color .15s, background-color .15s",
      "&:hover": {
        borderColor: checked ? theme.palette.primary.main : colors.slate400,
      },
      "& .MuiFormControlLabel-label": {
        fontSize: 14,
        lineHeight: 1.45,
        color: colors.slate700,
        pt: "1px",
      },
      ...sx,
    })}
    control={
      <Checkbox
        size="small"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        sx={{ p: 0, mt: "1px" }}
      />
    }
    label={label}
  />
);

export default CheckboxRow;
